export default __webpack_public_path__ + "static/media/robot.baf396e6.png";